// extracted by mini-css-extract-plugin
export default {"btn_salvar":"Cadastro_btn_salvar__S8crb"};